import Navbar from "./components/Navbar";
import Hero from "./components/Hero"
import About from "./components/About"
import Tech from "./components/Tech"
import Education from "./components/Education"
import Projects from "./components/Projects";
import Contact from "./components/Contact";

function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <About />
      <Tech />
      <Projects />
      <Education />
      <Contact />

    </div>
  );
}

export default App;
